// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","715":"list","884":"admin"}[chunkId] || chunkId) + "." + {"594":"dac5dca4","612":"834e5123","715":"d9cc1765","884":"334c65c0"}[chunkId] + ".js";
};